import React from 'react';
import schoolgif from '../img/sch.gif';

export default function Contact(){
  return (
    <div id="contact" className="container-fluid py-5">
      <div className="container">
        <div className="text-center mb-4">
          <p className="section-title px-5"><span className="px-2">Get In Touch</span></p>
          <h1 className="mb-4">Contact Us</h1>
        </div>
        <div className="row align-items-center">
          <div className="col-lg-6 mb-5 mb-lg-0">
            <h3 className="mb-3"></h3>
          {/*  <p><i className="fa fa-map-marker-alt text-primary mr-2"></i> <strong>Address:</strong> Thoothukudi, Tamil Nadu</p>
            <p><i className="fa fa-phone text-primary mr-2"></i> <strong>Phone:</strong> +91-XXXX-XXXXXX</p>
            <p><i className="fa fa-envelope text-primary mr-2"></i> <strong>Email:</strong> info@stfrancisxavier.edu.in</p>
            <p className="mt-4">
              Have questions? We'd love to hear from you. Reach out to us anytime during school hours or fill the form to get a response.
            </p>*/}
            <img className="img-fluid rounded mb-5 mb-lg-0" src={schoolgif} alt="About" style={{objectFit:'cover'}} />
         
          </div>
          <div className="col-lg-6">
            <div className="card border-0">
              <div className="card-body rounded-bottom bg-light p-4">
                <form>
                  <div className="form-group">
                    <input type="text" className="form-control" placeholder="Your Name" required />
                  </div>
                  <div className="form-group">
                    <input type="email" className="form-control" placeholder="Your Email" required />
                  </div>
                  <div className="form-group">
                    <textarea className="form-control" rows="3" placeholder="Your Message" required></textarea>
                  </div>
                  <div>
                    <button className="btn btn-primary btn-block" type="submit">Send Message</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
